

export function checkIsFigureEnclosed(tool, enclosed) {
    const toolType = tool.split("-")[0];
    return ["p", "pl", "pr"].includes(toolType) || (toolType === "c" && enclosed);
}
